import {Injectable} from '@angular/core';
import {fromEvent, merge, Observable} from 'rxjs';
import {share} from 'rxjs/operators';
import {WindowRefService} from '../../services/window-ref.service';
import {CellSizeObserverService} from '../dashboard/layout/cell/cell-size-observer.service';

@Injectable()
export class WidgetPageCellSizeObserverService extends CellSizeObserverService {

    constructor(
        private windowRefService: WindowRefService
    ) {
        super();

        this.resize$ = this.createResizeStream();
    }

    private createResizeStream(): Observable<any> {
        return merge(
            this.resizeSubject$.asObservable(),
            fromEvent(this.windowRefService.nativeWindow, 'resize')
        ).pipe(
            share()
        );
    }

}
